import axiosBaseService from './base-axios-api'

export default class BaseApi {
  constructor(url) {
    this.url = url
  }

  encodeQueryData(data) {
    const ret = []
    for (const d in data) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
    }
    return ret.join('&')
  }

  getUrlWithParams(url, parameters) {
    var querystring = this.encodeQueryData(parameters)
    return url + '?' + querystring
  }

  composeUrl(...parts) {
    const urlSeparator = '/'

    parts = parts.map(p => p ? p.toString() : '')

    const res = parts
      .filter(p => p.length > 0)
      .map(p => {
        if (p.charAt(0) === urlSeparator) p = p.substr(1)
        if (p.charAt(p.length - 1) === urlSeparator) p = p.substr(0, p.length - 1)
        return p
      })
      .join(urlSeparator) + urlSeparator

    // console.log(parts)
    // console.log(res)

    return res
  }

  callGet(u = '', q) {
    return axiosBaseService({
      url: this.composeUrl(this.url, u),
      method: 'get',
      params: q
    }).then(r => r.data)
  }

  callPost(u = '', m) {
    return axiosBaseService({
      url: this.composeUrl(this.url, u),
      method: 'post',
      data: m
    })
  }

  callPut(u = '', m) {
    return axiosBaseService({
      url: this.composeUrl(this.url, u),
      method: 'put',
      data: m
    })
  }

  callPatch(u = '', m) {
    return axiosBaseService({
      url: this.composeUrl(this.url, u),
      method: 'patch',
      data: m
    })
  }

  callDelete(u = '', m) {
    return axiosBaseService({
      url: this.composeUrl(this.url, u, m.id),
      method: 'delete'
    })
  }
}